import React from 'react';
import { Redirect } from 'react-router-dom';
import { useQuery } from 'react-query';
import { findPendingInvitesForEmail } from '../services/invitesClient';

const queryKeyPendingInvites = (email) => ['invites', 'pendingForEmail', email];

/**
 * When onboarding is not completed, prefer redirecting to a pending add-employee
 * invitation (if any) instead of the generic onboarding wizard.
 */
export default function PendingInviteOrOnboardingRedirect({ email }) {
  const normalized = email?.trim().toLowerCase() || '';

  const { data, isLoading, isError } = useQuery(
    queryKeyPendingInvites(normalized),
    () => findPendingInvitesForEmail(normalized),
    {
      enabled: !!normalized,
      staleTime: 30 * 1000,
    }
  );

  if (!normalized) {
    return <Redirect to="/onboarding" />;
  }

  if (isLoading) {
    return null;
  }

  if (!isError && data && data.length > 0) {
    return <Redirect to="/invitations-hub" />;
  }

  return <Redirect to="/onboarding" />;
}
